export const LivesApiCredentials = {
    adminName: "adminFrontInitL1v3sHr",
    password: "h4B6cDLSqQTEW47fbSya4zRvuRkDnm8R"
}